import { useState, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Button } from 'foundations-components/transitional/components/Button';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { ThreeDotsIcon } from 'foundations-assets/icons/components/ThreeDotsIcon';
import { DeleteDealPlanModalComponent } from 'deal-plans-lib/components/dealPlan/DeleteDealPlanModalComponent';
import { useDeleteDealPlanMutation } from '../../../__generated__/chirp/com/hubspot/deal/plans/rpc/DealPlanPortalRpc.hooks';
import { getFullUrl } from 'hubspot-url-utils';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import { getPortalAccountId } from '../../utils/portalMetaUtils';
import { usePortalTracking } from '../../hooks/usePortalTracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DealPlanMenuButton = props => /*#__PURE__*/_jsx(IconButton, Object.assign({}, props, {
  "aria-label": I18n.text('dealPlan.menu.label'),
  use: "tertiary-transparent",
  size: "medium",
  marginInline: "0",
  children: /*#__PURE__*/_jsx(ThreeDotsIcon, {})
}));
export function DealPlanHeaderMenu({
  dealPlanId,
  dealId,
  isShared,
  readOnly
}) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteDealPlan, {
    loading: isDeleting
  }] = useDeleteDealPlanMutation();
  const {
    trackDeleteClicked
  } = usePortalTracking(dealId);
  const handleDeleteClick = useCallback(() => {
    setShowDeleteModal(true);
  }, []);
  const handleConfirmDelete = useCallback(() => {
    trackDeleteClicked();
    void deleteDealPlan({
      variables: {
        objectId: dealPlanId
      }
    }).then(() => {
      const accountId = getPortalAccountId();
      if (accountId == null) {
        return;
      }
      window.location.href = `${getFullUrl('app')}/contacts/${accountId}/record/0-3/${dealId}`;
    }).catch(() => {
      FloatingAlertStore.addAlert({
        type: 'danger',
        titleText: I18n.text('dealPlan.deleteDealPlan.errorTitle'),
        message: I18n.text('dealPlan.deleteDealPlan.errorMessage')
      });
    });
  }, [dealPlanId, dealId, deleteDealPlan, trackDeleteClicked]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Dropdown, {
      Button: DealPlanMenuButton,
      "data-test-id": "deal-plan-header-menu",
      children: /*#__PURE__*/_jsx(List, {
        children: /*#__PURE__*/_jsx(ListItem, {
          children: readOnly ? /*#__PURE__*/_jsx(Tooltip, {
            title: I18n.text('dealPlan.menu.readOnlyTooltip'),
            children: /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(Button, {
                use: "transparent",
                size: "extra-small",
                block: true,
                disabled: true,
                children: /*#__PURE__*/_jsxs(Flex, {
                  alignItems: "center",
                  gap: "100",
                  children: [/*#__PURE__*/_jsx(DeleteIcon, {
                    color: "icon-core-disabled",
                    size: "200"
                  }), /*#__PURE__*/_jsx(Text, {
                    use: "disabled",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "dealPlan.menu.delete"
                    })
                  })]
                })
              })
            })
          }) : /*#__PURE__*/_jsx(Button, {
            use: "transparent",
            size: "extra-small",
            block: true,
            onClick: handleDeleteClick,
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "100",
              children: [/*#__PURE__*/_jsx(DeleteIcon, {
                color: "icon-alert-default",
                size: "200"
              }), /*#__PURE__*/_jsx(Text, {
                color: "icon-alert-default",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "dealPlan.menu.delete"
                })
              })]
            })
          })
        })
      })
    }), showDeleteModal && /*#__PURE__*/_jsx(DeleteDealPlanModalComponent, {
      isShared: isShared,
      isDeleting: isDeleting,
      onConfirm: handleConfirmDelete,
      onClose: () => setShowDeleteModal(false)
    })]
  });
}